var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationManLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-2V31c0-4.962 4.037-9 9-9v2c-3.859 0-7 3.14-7 7v11M58 42h-2V31c0-3.86-3.141-7-7-7v-2c4.963 0 9 4.038 9 9v11M24 70h32V50c0-1.103-.897-2-2-2H26c-1.103 0-2 .897-2 2v20zm33 2H23a1 1 0 01-1-1V50c0-2.206 1.794-4 4-4h28c2.206 0 4 1.794 4 4v21a1 1 0 01-1 1z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.895 71.447l-1.79-.894L59 64.764V60h-2v-2h3a1 1 0 011 1v6c0 .155-.036.309-.105.447l-3 6M22.105 71.447l-3-6A1.002 1.002 0 0119 65v-6a1 1 0 011-1h3v2h-2v4.764l2.895 5.789-1.79.894M40 57c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 53h-2v-2c0-8.01 4.445-9.7 9.152-11.489 1.743-.661 3.544-1.346 5.352-2.379l.992 1.736c-1.943 1.111-3.903 1.856-5.633 2.513C22.128 43.181 19 44.369 19 51v2M63 53h-2v-3c0-6.301-2.73-7.167-7.254-8.601-1.909-.605-4.072-1.291-6.242-2.531l.992-1.736c1.984 1.134 3.952 1.758 5.855 2.361C58.799 40.903 63 42.235 63 50v3",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 72v-2h7.003A1.997 1.997 0 0070 68.006V55.994A1.996 1.996 0 0067.997 54H57v-2h11a4 4 0 014 4v12a4 4 0 01-4.002 4H61zM12.002 72A4.002 4.002 0 018 68V56c0-2.21 1.794-4 4-4h11v2H12.003A2 2 0 0010 55.994v12.012c0 1.101.896 1.994 1.997 1.994H19v2h-6.998z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 38.882l3.803 1.901 2.91-2.91-1.187-1.78-5.526.921-5.526-.921-1.187 1.78 2.91 2.91L40 38.882zm4.197 4.335L40 41.118l-4.197 2.099-5.09-5.09 2.813-4.22L40 34.986l6.474-1.079 2.813 4.22-5.09 5.09z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M44 35h2v-4h-2zM34 35h2v-4h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 33c-.132 0-3.261-.013-5.447-1.105l-.108-.063c-.137-.092-3.383-2.332-4.435-9.69L30 22v-4h2v3.928c.861 5.917 3.2 7.961 3.519 8.213 1.762.845 4.455.859 4.482.859.025 0 2.717-.014 4.478-.859.313-.249 2.661-2.304 3.521-8.213V18h2l-.01 4.142c-1.052 7.358-4.298 9.598-4.435 9.69l-.108.063C43.261 32.987 40.132 33 40 33M50 18h-2c0-5.533-2.468-8-8-8s-8 2.467-8 8h-2c0-6.636 3.364-10 10-10s10 3.364 10 10",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M45.046 21.095l-10-4-3.599 1.8-.894-1.79 4.401-2.2 10 4 3.599-1.8.894 1.79-4.401 2.2",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationManLaptop;